import { useLayoutEffect, useRef } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useAppConfig } from "@ct-react/core";
import { useElementSize } from "../../hooks/dom";
import { Wrapper } from "./wrapper";
import { LocaleLink, useLocaleContext } from "@ct-react/locale";
import { menu_translations } from "../../i18n/sharable-defs";

import "./footer.scss";

import Logo from "../../assets/componable-svgs/Logo-texte-white.svg";
import LogoNendaz from "../../assets/componable-svgs/Logo-Nendaz-blanc.svg";
import LogoNVRM from "../../assets/componable-svgs/Logo-nvrm-blanc.svg";
import LogoUSPI from "../../assets/componable-svgs/logo-blanc-uspi.svg";
import SpriteIcon from "../medias/sprite-icon";

export const transdefs = defineMessages({
  partner: { id: "footer.our-partners", defaultMessage: "Nos partenaires exclusifs" },
});

const Footer = () => {

  const intl = useIntl();
  const { locale } = useLocaleContext();
  const { id: agency } = useAppConfig();
  const year = useRef<number>(new Date().getFullYear());

  const { ref, size } = useElementSize();

  useLayoutEffect(() => {
    !!size?.height && document.documentElement.style.setProperty("--cgv-footer-height", `${size.height}px`);
  }, [ size?.height ]);

  return (
    <footer ref={ref}
            className="main-footer"
            role="contentinfo">
      <Wrapper.Centered>

        <div className="brand keep">
          <LocaleLink to={"/"} aria-label="Retour à l'accueil">
            <Logo />
          </LocaleLink>
        </div>

        <div>
          <p className="sub">INTER-AGENCE</p>
          <address>
            <a href="https://maps.app.goo.gl/zPr4Hegvw7EqCehE9" target="_blank" rel="noopener noreferrer">
              <SpriteIcon hash="contact.pin-location"/>
              Route de la Télécabine 3<br/>
              1997 Haute-Nendaz
            </a>
          </address>
        </div>

        <div>
          <p className="sub">CONTACT</p>
          <address>
            <a href="tel:0041272882319">
              <SpriteIcon hash="contact.phone"/>
              +41 27 288 23 19
            </a>
            <a href="mailto:info@inter-agence.ch">
              <SpriteIcon hash="contact.email"/>
              info@inter-agence.ch
            </a>
          </address>
        </div>

        <div>
          <p className="sub">{intl.formatMessage(transdefs.partner)}</p>
          <div className="partners">
            <a href="https://www.nendaz.ch/fr/" target="_blank" aria-label="Visitez le site de Nendaz">
              <LogoNendaz/>
            </a>
            <a href="https://www.nvrm.ch/" target="_blank" aria-label="Visitez le site de NVRM">
              <LogoNVRM/>
            </a>
            <a href="https://www.uspi.ch/" target="_blank" aria-label="Visitez le site de l'USPI">
              <LogoUSPI/>
            </a>
          </div>
        </div>

        <span className="copyright">
          <span>
            <a href={`/public/mentions-legales-${locale.basename}.pdf`} target="_blank">
              {intl.formatMessage(menu_translations.legal_notice)}
            </a>
            &nbsp;|&nbsp;
            <a href={`/public/politiques-confidentialite-${locale.basename}.pdf`} target="_blank">
              {intl.formatMessage(menu_translations.privacy_policy)}
            </a>
          </span>
          <span>
            {intl.formatMessage({
              id: "footer.copyright",
              defaultMessage: "© {year} {agency} tous droits réservés | développé par {ct}"
            }, {
              year: year.current,
              agency,
              ct: <a key="ct" href="https://www.creative-technologies.ch" target="_blank">C.T. Creative Technologies SA</a>
            })}
          </span>
        </span>
      </Wrapper.Centered>
    </footer>);

};

export default Footer;
